import { TFunction } from "i18next";
import {
  PositionOption,
  StagePosition
} from "@/pages/settings/components/shared/stageStudio/types";
import { getStagePositionOptions } from "@/pages/settings/components/shared/stageStudio/getPositionOptions";
import { OnboardingStage } from "@/pages/settings/components/contractsSettings/types";

const CREATE_STAGE_TRANSLATION_KEY =
  "settings.contracts.onboardingStudio.createStage";

export const getPositionOptions = (
  stages: OnboardingStage[],
  t: TFunction<"translation", undefined>,
  currentStage?: OnboardingStage
): PositionOption[] =>
  getStagePositionOptions(
    stages,
    t,
    CREATE_STAGE_TRANSLATION_KEY,
    currentStage
  );

export const getCurrentStagePosition = (
  currentStage: OnboardingStage,
  allStages: OnboardingStage[]
): string => {
  const currentIndex = allStages.findIndex((s) => s.id === currentStage.id);
  if (currentIndex === -1) return StagePosition.LAST;
  if (currentIndex === 0) return StagePosition.FIRST;
  if (currentIndex === allStages.length - 1) return StagePosition.LAST;
  return `${StagePosition.AFTER_PREFIX}${allStages[currentIndex - 1].id}`;
};
